export const obtenerUrlAPIReporteDocente = (uri) => {
  return `${process.env.VUE_APP_URL_API_SIG_ACADEMICO || ''}/api/${uri}`;
};
